var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteAddFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33.3334C17.5 33.9965 17.7634 34.6323 18.2322 35.1012C18.701 35.57 19.3369 35.8334 20 35.8334C20.663 35.8334 21.2989 35.57 21.7677 35.1012C22.2366 34.6323 22.5 33.9965 22.5 33.3334V22.5001H33.3333C33.9963 22.5001 34.6322 22.2367 35.1011 21.7678C35.5699 21.299 35.8333 20.6631 35.8333 20.0001C35.8333 19.337 35.5699 18.7012 35.1011 18.2323C34.6322 17.7635 33.9963 17.5001 33.3333 17.5001H22.5V6.66675C22.5 6.00371 22.2366 5.36782 21.7677 4.89898C21.2989 4.43014 20.663 4.16675 20 4.16675C19.3369 4.16675 18.701 4.43014 18.2322 4.89898C17.7634 5.36782 17.5 6.00371 17.5 6.66675V17.5001H6.66663C6.00358 17.5001 5.3677 17.7635 4.89886 18.2323C4.43002 18.7012 4.16663 19.337 4.16663 20.0001C4.16663 20.6631 4.43002 21.299 4.89886 21.7678C5.3677 22.2367 6.00358 22.5001 6.66663 22.5001H17.5V33.3334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteAddFill);
export default __webpack_public_path__ + "static/media/mingcute_add-fill.d5c9c08041f16cf3462e06a8f265de6f.svg";
export { ForwardRef as ReactComponent };